import FormularyForm from './FormularyForm';

export default FormularyForm;
